import instance from '@apis/instance';
import { GetGiftItemsParams, GiftItemNutritionFactsResponse, GiftItemRow } from '@models/gift';

class GiftItemApi {
    static getGiftItems(params: GetGiftItemsParams): Promise<GiftItemRow[]> {
        return instance.get('/v0/gift-items', { params });
    }

    static getGiftItem(id: string): Promise<GiftItemRow> {
        return instance.get(`/v0/gift-item/${id}`);
    }

    static getGiftItemNutritionFacts(giftItemId: string): Promise<GiftItemNutritionFactsResponse> {
        return instance.get(`/v0/gift-item/${giftItemId}/nutrition-facts`);
    }
}

export default GiftItemApi;
